import { render, staticRenderFns } from "./miniprogramCard.vue?vue&type=template&id=9b50125c"
import script from "./miniprogramCard.vue?vue&type=script&lang=js"
export * from "./miniprogramCard.vue?vue&type=script&lang=js"
import style0 from "./miniprogramCard.vue?vue&type=style&index=0&id=9b50125c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports